// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class CourseReservesController {
   $element: any
   $location: any
   $route: any
   $scope: any
   courseReserves: any
   constructor($scope: any, courseReserves: any, $route: any, $routeParams: any, $location: any, $element: any){

      this.goDetailDocs = this.goDetailDocs.bind(this)
      this.runCourseReserveSearch = this.runCourseReserveSearch.bind(this)
      this.runNewSearch = this.runNewSearch.bind(this)
      this.$scope = $scope
      this.courseReserves = courseReserves
      this.$route = $route
      this.$location = $location
      this.$element = $element
      this.$scope.courseReserves = this.courseReserves.scope
      this.$scope.courseReserveDetail = this.courseReserves.detailScope
      this.$scope.runCourseReserveSearch = this.runCourseReserveSearch
      this.$scope.goDetailDocs = this.goDetailDocs
      this.$scope.checkNewSearch = this.courseReserves.checkNewSearch
      this.$scope.runNewSearch = this.runNewSearch
      this.$scope.inf = Infinity

      // document-summary number results will be shown when displayResultCounts and resultNumber are set
      this.$scope.displayResultCounts = true

      if (this.$route.current.action === 'detail') {
         this.courseReserves.setDetailed($routeParams.course_id)
      }

      //First Run in the view
      if (this.$element.is('#courseReservesView')) { this.runNewSearch() }
   }

   goDetailDocs(id: any) {
      return this.$location.path('/course_reserves/' + id)
   }

   runCourseReserveSearch() {
      this.$location.path('/course_reserves')
      return this.courseReserves.runSearch()
   }

   runNewSearch() {
      this.courseReserves.runNewSearch()
      const searchBox = this.$element.find('.search-input')
      if (searchBox.length) { return searchBox.focus() }
   }
}

CourseReservesController.$inject = ['$scope', 'courseReserveService', '$route', '$routeParams', '$location', '$element']

angular.module('summonApp.controllers')
   .controller('CourseReservesCtrl', CourseReservesController)
